import { ref } from 'vue'
import getSensorData from '../../../../composables/getSensorData'

const processTestData = () => {
  const testData = ref([])
  const shouldRenderTestCharts = ref(false)

  const { fetchTimeData, fetchDataForChart } = getSensorData()

  const renderTestCharts = async (sessionId, userDevices) => {
    const timeData = await fetchTimeData(sessionId)

    const promises = []

    // Use a loop to generate the promises
    for (let i = 0; i <= 31; i++) {
      promises.push(fetchDataForChart(sessionId, `P${i}`, userDevices, timeData))
    }

    Promise.all(promises).then((res) => {
      let groupData = []

      // Map the results to testData.value
      testData.value = res.map((data, index) => ({
        id: `test-sensor-${index}`,
        title: `P${index}`,
        data: data
      }))

      testData.value.forEach((data) => {
        groupData.push({
          name: data.title,
          data: data.data[0].data
        })
      })

      const side = res[0][0].name
      testData.value.push({ id: `test-${side}-group`, title: `${side} Group`, data: groupData })

      if (res[0].length > 1) {
        groupData = []
        testData.value = testData.value.filter((data) => data.data)
        testData.value.forEach((data) => {
          groupData.push({
            name: data.title,
            data: data.data[1].data
          })
        })
        const side = res[0][1].name
        testData.value.push({ id: `test-${side}-group`, title: `${side} Group`, data: groupData })
      }

      shouldRenderTestCharts.value = true
    })
  }

  return { testData, shouldRenderTestCharts, renderTestCharts }
}

export default processTestData
